import React from "react";
import {NavLink} from "react-router-dom";
import './Breadcrumbs.scss';

interface BreadcrumbsProps {
    path: string,
    callback?: (s?: string) => void,
    className?: string
}

const Breadcrumbs = (props: BreadcrumbsProps) => {

    const getPathDivisions = (): string[] => {
        return props.path.split('/');
    }

    const getSectionProperName = (name: string): string => {
        return name.split(/[\s-_]+/g)
            .map(namePart => namePart.toUpperCase().charAt(0)
                + namePart.substring(1)).join(' ');
    }

    const runCallback = (): void => {
        if (props.callback) {
            props.callback();
        }
    }

    return (
        <div className="breadcrumbs">
            {getPathDivisions().map((division, index) =>
                (<React.Fragment key={`breadcrumbs-${index}`}>
                    {index > 0 && <span>&gt;</span>}
                    {(index < getPathDivisions().length - 1)
                        ? <NavLink to={`/${getPathDivisions().slice(0, index + 1).join('/')}`}
                                   className={`block${props.className ? ' ' + props.className : ''}`}
                                   onClick={() => runCallback()}>
                            {getSectionProperName(division)}
                        </NavLink>
                        : <span className="block">{getSectionProperName(division)}</span>}
                </React.Fragment>)
            )}
        </div>
    );
}

export default Breadcrumbs;